import { FaEdit } from "react-icons/fa";

export default () => {
  var Numitem = ({ item }: any) => (
    <div className="border border-gray-200 border-1 p-2 rounded flex flex-col items-center justify-center ">
      <p>{item.name}</p>
      <p className="font-bold text-[18px]" >{item.value}</p>
    </div>
  );
  const leaveRequestnumbers = [
    { name: "Rejected", value: 4 },
    { name: "Approved", value: 6 },
    { name: "Pending", value: 3 },
  ];
  return (
  
  
  <div className="flex   border border-1 border-gray-200 rounded justify-between p-4 ">
    <div className=" ">
      <p className=" text-sm my-4 ">Leave balances </p>
      <div className=" grid grid-cols-4 gap-4 mx-6">

      {leaveRequestnumbers.map((kk:any)=><Numitem item={kk}/>)}

      </div>


      <p  className=" text-sm m-4" >Leave request </p>

      <div className=" grid grid-cols-4 gap-4 mx-6">

{leaveRequestnumbers.map((kk:any)=><Numitem item={kk}/>)}

</div>
    </div>
<span className="text-primary text-sm font-semibold"><FaEdit className="inline" size={20}/>Edit</span>
    </div>
  );
};
